import { ListingSyncErrorsUI } from 'features/Dealers/Listings/state/types';

export const getSyncError = (entityProp: string, listingSyncErrors?: ListingSyncErrorsUI) => {
    if(!listingSyncErrors || !listingSyncErrors?.fieldsErrors)
    {
        return undefined;
    }
    let syncError = listingSyncErrors?.fieldsErrors.find((fieldError) => fieldError.fieldName==entityProp);
    if(!syncError)
    {
        for(let i=0;i<listingSyncErrors?.fieldsErrors.length;i++)
        {
            if(listingSyncErrors?.fieldsErrors[i].fieldName.indexOf("[")!=-1)
            {
                let field=listingSyncErrors?.fieldsErrors[i].fieldName.substr(0,listingSyncErrors?.fieldsErrors[i].fieldName.indexOf("["));
                if(field==entityProp)
                {
                    return listingSyncErrors?.fieldsErrors[i].errorMessage;
                }
            }
        }
    }
    else
    {
        return syncError?.errorMessage;
    }
}

export const phoneFormat = (phone: string) => {
    var x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x) return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    else return "";
}

